<script lang="ts">
	import { format } from 'src/services/i18n';
	import { Alert, Button, Modal } from '@Shelly/shelly-design-system/index';

	let showConfirmModal = false;
	let resolver: (ok: boolean) => void = null;

	/** Open the modal and resolve with true/false when user confirms/cancels */
	export const confirm = async (): Promise<boolean> => {
		// prevent re-entry if a previous confirm is still pending
		if (resolver) return Promise.resolve(false);
		showConfirmModal = true;
		return new Promise<boolean>((resolve) => (resolver = resolve));
	};

	const onConfirm = (value: boolean) => {
		showConfirmModal = false;
		resolver?.(value);
		resolver = null; // clear pending resolver
	};
</script>

<!-- Confirmation Modal -->
<Modal
	on:close={() => {
		onConfirm(false);
	}}
	showModal={showConfirmModal}
	title={$format('irrigation_in_progress_title', {
		default: 'Irrigation in Progress!',
	})}
>
	<div slot="content">
		<Alert
			type="warning"
			heading={$format('irrigation_interrupt_warning', {
				default:
					'Performing this action will interrupt the currently running irrigation. Do you want to continue?',
			})}
		/>
		<div class="d-flex justify-content-end" style="margin-top: 20px;">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				variant="secondary"
				responsiveSize={{
					sm: 'm',
				}}
				on:click={() => {
					onConfirm(false);
				}}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{
					sm: 'm',
				}}
				on:click={() => {
					onConfirm(true);
				}}
			>
				{$format('button_continue', {
					default: 'Continue',
				})}
			</Button>
		</div>
	</div>
</Modal>
